'use strict';
var BASWebServices;
(function (BASWebServices) {
    var TrustedHtmlFilter = (function () {
        function TrustedHtmlFilter() {
        }
        TrustedHtmlFilter.Factory = function ($sce) {
            return function (htmlText) {
                return $sce.trustAsHtml(htmlText);
            };
        };
        return TrustedHtmlFilter;
    }());
    BASWebServices.TrustedHtmlFilter = TrustedHtmlFilter;
})(BASWebServices || (BASWebServices = {}));
//# sourceMappingURL=TrustedHtmlFilter.js.map